export type TaskProps = {
  id: string | undefined
  title: string
  description: string
  idObject: string
  date: Date
  category: number
  userID: string
}

export class Task {
  private readonly _id: string | undefined
  private readonly _title: string
  private readonly _description: string
  private readonly _idObject: string
  private readonly _date: Date
  private readonly _category: number
  private readonly _userID: string

  constructor(p: TaskProps) {
    this._id = p.id
    this._title = p.title
    this._description = p.description
    this._idObject = p.idObject
    this._date = p.date
    this._category = p.category
    this._userID = p.userID
  }

  get id(): string | undefined {
    return this._id
  }

  get title(): string {
    return this._title
  }

  get description(): string {
    return this._description
  }

  get idObject(): string {
    return this._idObject
  }

  get date(): Date {
    return this._date
  }

  get category(): number {
    return this._category
  }

  get userID(): string {
    return this._userID
  }
}

export interface TaskQuery {}
